<template>
    <el-card shadow="hover">
        <label slot="header">地址级联选择（插件数据源）</label>
        <el-divider content-position="left">选择模式</el-divider>
        <j-address v-model="address" @change="v => { addressChange = v }" placeholder="请选择地址" />
        <span style="color: #409EFF;">change事件：{{addressChange}}</span>
        <el-divider content-position="left">通过code解析对应城市</el-divider>
        <j-address type="text" :value="address" />
        <el-divider content-position="left">仅显示最后一级地址（emitPath="false"）</el-divider>
        <j-address value-type="String" v-model="lastAddress" @change="v => { lastAddressChange = v }" placeholder="请选择地址" :emitPath="false" />
        <span style="color: #409EFF;">change事件：{{lastAddressChange}}</span>
        <el-divider content-position="left">通过code解析对应城市</el-divider>
        <j-address value-type="String" type="text" :value="lastAddress" :emitPath="false" />
    </el-card>
</template>

<script>
    import JAddress from "./JAddress";
    export default {
        name: "JAddressDemo",
        components: {
            JAddress
        },
        data() {
            return {
                address:  '',
                addressChange: '',
                lastAddress: '',
                lastAddressChange: '',
            }
        }
    }
</script>
